import {
  SET_CHAT_DATA,
  SET_SHOW_CHAT_FORM,
  SET_SHOW_FORM,
  SET_AGENT_LEFT,
  SET_CHAT_TYPE,
} from "../../Redux/Actions/type";

const initialState1 = {
  showChatForm: true,
  showform: true,
  chatData: "",
  agentLeft: false,
  chatType: "Text",
};

export const customerPortalReducer = (state = initialState1, action) => {
  switch (action.type) {
    case SET_SHOW_CHAT_FORM:
      return {
        ...state,
        showChatForm: action.val,
      };
    case SET_SHOW_FORM:
      return {
        ...state,
        showform: action.val,
      };
    case SET_CHAT_DATA:
      return {
        ...state,
        chatData: action.val,
      };
    case SET_AGENT_LEFT:
      return {
        ...state,
        agentLeft: action.val,
      };
    case SET_CHAT_TYPE:
      return {
        ...state,
        chatType: action.val,
      };
    default:
      return state;
  }
};
